var map = {
	"./AMBIANCE ELEMENTS_1.wav": 78,
	"./CLAP_1.wav": 79,
	"./Jack Guit_1.wav": 80,
	"./Main Guit_1.wav": 81,
	"./TUC - Vintage Worm 1_1.wav": 82,
	"./core drum_1.wav": 83,
	"./moog synth_1.wav": 84,
	"./simple drum_1.wav": 85
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77;